// Cambio de contraseña propia.
//
// Es también la pantalla obligatoria de quien entra con una contraseña generada
// por el administrador: hasta que la cambie, el servidor le responde 403 a todo
// lo demás. El corte lo hace el backend; esta página solo lo hace llevadero.
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/client";
import { useAuthStore } from "../stores/auth";
import { Card, ErrorBanner, PageHeader, Spinner } from "../components/Layout";

export default function CambiarPasswordPage() {
  const navigate = useNavigate();
  const { me, refresh } = useAuthStore();
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [repetida, setRepetida] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState(false);
  const [enviando, setEnviando] = useState(false);

  const obligatorio = Boolean(me?.debe_cambiar_password);

  const enviar = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (nueva !== repetida) {
      setError("Las dos contraseñas nuevas no coinciden.");
      return;
    }
    setEnviando(true);
    try {
      await api.post("/api/me/password", { password_actual: actual, password_nueva: nueva });
      setOk(true);
      await refresh();
      setTimeout(() => navigate("/dashboard"), 1200);
    } catch (err) {
      setError(err instanceof Error ? err.message : "No se pudo cambiar la contraseña.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 max-w-lg mx-auto">
      <PageHeader
        title="Cambiar contraseña"
        subtitle={
          obligatorio
            ? "Entraste con una contraseña creada por el administrador: cámbiala para poder usar el panel."
            : "Elige una contraseña nueva."
        }
      />
      <Card>
        <form onSubmit={enviar}>
          <label className="etiqueta">Contraseña actual</label>
          <input
            type="password"
            required
            autoComplete="current-password"
            className="input mb-3"
            value={actual}
            onChange={(e) => setActual(e.target.value)}
          />

          <label className="etiqueta">Contraseña nueva</label>
          <input
            type="password"
            required
            minLength={8}
            autoComplete="new-password"
            className="input mb-1"
            value={nueva}
            onChange={(e) => setNueva(e.target.value)}
          />
          <p className="text-xs text-tinta-3 mb-3">Mínimo 8 caracteres.</p>

          <label className="etiqueta">Repite la contraseña nueva</label>
          <input
            type="password"
            required
            autoComplete="new-password"
            className="input mb-4"
            value={repetida}
            onChange={(e) => setRepetida(e.target.value)}
          />

          {error && <div className="mb-3"><ErrorBanner message={error} /></div>}
          {ok && (
            <div className="mb-3 p-3 rounded-md bg-estado-ok/10 border border-estado-ok/40 text-sm text-tinta-2">
              Contraseña actualizada. Entrando al panel…
            </div>
          )}

          <div className="flex flex-wrap items-center gap-3">
            <button type="submit" className="btn" disabled={enviando}>
              {enviando ? "Guardando…" : "Cambiar contraseña"}
            </button>
            {enviando && <Spinner />}
          </div>
        </form>
      </Card>
    </div>
  );
}
